import { Box, Button, Grid, Typography } from '@mui/material'
import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { IDocument } from 'hooks/useHelpDocument/useHelpDocument'
import replaceDocumentRoute from './helper/replaceDocumentRoute'

export default function RelateDocuments({
    relateDocumentTitles,
    docs,
}: {
    relateDocumentTitles: string[]
    docs: IDocument[]
}) {
    const history = useHistory()
    const onSelectRelatedDocument = useCallback(
        (title: string) => {
            const selectedDocument = docs.find((i) => i.title === title)
            if (selectedDocument)
                history.push(
                    replaceDocumentRoute(selectedDocument.category, title),
                )
        },
        [docs, history],
    )

    return (
        <Box marginY={4}>
            <Typography variant="h6" sx={{ marginBottom: 3 }}>
                Related documents
            </Typography>
            <Grid container spacing={1}>
                {relateDocumentTitles.map((title, index) => (
                    <Grid item key={index}>
                        <Button
                            variant="outlined"
                            fullWidth
                            sx={{ padding: 2 }}
                            onClick={() => onSelectRelatedDocument(title)}
                        >
                            📄 {title}
                        </Button>
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}
